<template>
  <v-layout
    v-if="isLoading"
    fill-height
    align-center
    justify-center
    ma-0
  >
    <v-progress-circular
      indeterminate
      color="primary"
    />
  </v-layout>
  <div
    v-else
    class="noWrap"
  >
    {{ clientName || getId }}
  </div>
</template>

<script>
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import ClientRequest from '@/app/client/ClientRequest';

export default {
  name: 'ClientNameColumn',
  mixins: [ServiceMixin],
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  data: () => ({
    clientName: '',
    loading: false,
    requestClass: ClientRequest,
    swalConfig: {
      showSuccessSwal: false,
      errorMessage: 'Falha ao buscar nome do cliente!',
    },
  }),
  computed: {
    getId() {
      return this.value;
    },
    isLoading() {
      return this.loading;
    },
  },
  watch: {
    getId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.getData();
        }
      },
    },
  },
  methods: {
    getData() {
      this.handleLogin();
      this.makeRequest();
    },
    handleLogin() {
      this.loading = !this.loading;
    },
    makeRequest() {
      this.callService(
        this.requestClass.get(
          this.getId,
        ),
        this.requestCb,
        this.swalConfig,
      );
    },
    requestCb(response) {
      this.handleLogin();
      if (response && response.data) {
        this.clientName = response.data.nomCliente;
      }
    },
  },
};
</script>
